import React from 'react'
import { Placeholder, VisitorIdentification, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react'
import { withTranslation } from 'react-i18next'

import Helmet from 'react-helmet'

const Layout = ({ sitecoreContext, route, t }) => {
  return (
    <React.Fragment>
      {/* react-helmet enables setting <head> contents, like title and OG meta tags */}
      <Helmet></Helmet>

      {/* <VisitorIdentification /> TODO uncomment later once tracking is set up */}

      <Placeholder name="DiscoveryJssHeadPH" rendering={route} />
      <div>
        <Placeholder name="DiscoveryJssHeaderPH" rendering={route} />
        <main>
          <Placeholder name="DiscoveryJssMainPH" rendering={route} />
        </main>
        <Placeholder name="DiscoveryJssFooterPH" rendering={route} />
      </div>
      <Placeholder name="DiscoveryJssBottomPH" rendering={route} />
    </React.Fragment>
  )
}

export default withSitecoreContext()(withTranslation()(Layout))
